import React from 'react';
import { SharedComponentsProps } from '../../../';

export enum actionInput {
  PLUS = 'plus',
  MINUS = 'minus',
}

export type InputQuantityProps = React.InputHTMLAttributes<HTMLInputElement> &
  SharedComponentsProps & {
    /**
     * Callback to get the quantity value
     */
    onChangeQuantity: (quantity: number) => void;
    /**
     * Label describing the input
     */
    label?: string;
    /**
     * Quantity to display in the input (default: 1)
     */
    quantity?: number;
    /**
     * Max quantity the input can display
     */
    maxQuantity?: string;
    /**
     * Min quantity the input can display
     */
    minQuantity?: string;
    /**
     * Select dropdown instead of input with button
     */
    isSelect?: boolean;
    /**
     * Allows user to change quantity
     */
    isEditable?: boolean;
    /**
     * Hide + / - buttons when component is not editable
     * Also hide select arrows.
     */
    hideActionsWhenComponentIsNotEditable?: boolean;
  };

export type StyledInputQuantityProps = {
  isSelect?: InputQuantityProps['isSelect'];
  customStyle?: InputQuantityProps['customStyle'];
};
